import React, { useCallback, useEffect, useRef, useState } from 'react';
import { generateCaptchaText } from '../../utils/captcha';

function drawCaptcha(canvas, text) {
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const w = canvas.width;
  const h = canvas.height;


  console.log(text);

  ctx.fillStyle = '#eef4fc';
  ctx.fillRect(0, 0, w, h);

  for (let i = 0; i < 6; i += 1) {
    ctx.strokeStyle = `rgba(26,79,168,${0.15 + Math.random() * 0.25})`;
    ctx.beginPath();
    ctx.moveTo(Math.random() * w, Math.random() * h);
    ctx.lineTo(Math.random() * w, Math.random() * h);
    ctx.stroke();
  }

  const charWidth = w / (text.length + 1);
  [...text].forEach((ch, i) => {
    ctx.save();
    ctx.font = `bold ${22 + Math.floor(Math.random() * 6)}px Arial, sans-serif`;
    ctx.fillStyle = `hsl(${210 + Math.random() * 30}, 65%, ${28 + Math.random() * 12}%)`;
    ctx.translate(charWidth * (i + 0.65), h / 2 + (Math.random() * 8 - 4));
    ctx.rotate((Math.random() - 0.5) * 0.35);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(ch, 0, 0);
    ctx.restore();
  });

  for (let i = 0; i < 40; i += 1) {
    ctx.fillStyle = `rgba(100,120,150,${Math.random() * 0.35})`;
    ctx.fillRect(Math.random() * w, Math.random() * h, 2, 2);
  }
}

export default function CaptchaField({
  value,
  onChange,
  onCodeChange,
  onRefresh,
  disabled,
  inputId = 'captcha-answer',
}) {
  const canvasRef = useRef(null);
  const [code, setCode] = useState(() => generateCaptchaText());

  const refresh = useCallback(() => {
    const next = generateCaptchaText();
    setCode(next);
    onChange('');
    onCodeChange?.(next);
    onRefresh?.();
  }, [onChange, onCodeChange, onRefresh]);

  useEffect(() => {
    onCodeChange?.(code);
  }, [code, onCodeChange]);

  useEffect(() => {
    drawCaptcha(canvasRef.current, code);
  }, [code]);

  return (
    <div className="captcha-field">
      <label htmlFor={inputId}>Verification code</label>
      <div className="captcha-row">
        <canvas ref={canvasRef} width={160} height={48} className="captcha-canvas" aria-hidden />
        <button
          type="button"
          className="captcha-refresh"
          onClick={refresh}
          disabled={disabled}
          title="Refresh code"
          aria-label="Refresh verification code"
        >
          <i className="ti ti-refresh" />
        </button>
      </div>
      <div className="login-input-wrap captcha-input-wrap">
        <i className="ti ti-shield" />
        <input
          id={inputId}
          type="text"
          placeholder="Enter the code shown above"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete="off"
          disabled={disabled}
          maxLength={8}
        />
      </div>
      <span className="captcha-hint">Letters are not case-sensitive</span>
    </div>
  );
}
